export const name = "LOWER";
export const summary = `Formats alphabetic characters in a \`STRING\` value as lowercase.        Formats ASCII characters in a \`BYTES\` value as lowercase.`;
export const reference = `
## LOWER

Formats alphabetic characters in a \`STRING\` value as lowercase.   
  
 Formats ASCII characters in a \`BYTES\` value as lowercase.

\`\`\`
LOWER(value)
\`\`\`

### Description

For \`STRING\` arguments, returns the original string with all alphabetic characters in lowercase. Mapping between lowercase and uppercase is done according to the Unicode Character Databasewithout taking into account language-specific mappings.

For \`BYTES\` arguments, the argument is treated as ASCII text, with all bytes greater than 127 left intact.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT
  LOWER('FOO BAR BAZ') AS example
FROM items;

/*-------------*
 | example |
 +-------------+
 | foo bar baz |
 *-------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
